import { Role } from '@okletsplay/core';
import { StoreName } from 'app/enums/store';
import { difference } from 'lodash';
import { store } from 'redux/store';

export const hasAllRoles = (requiredRoles: Role[] = [], userRoles?: Role[]): boolean => {
  if (requiredRoles.length === 0) {
    return true;
  }

  return (
    difference(
      requiredRoles,
      userRoles ?? store.getState()[StoreName.Session]?.entity?.user?.roles ?? []
    ).length === 0
  );
};
